import { render, staticRenderFns } from "./KimMJComponent.vue?vue&type=template&id=47b5716b&scoped=true"
import script from "./KimMJComponent.vue?vue&type=script&lang=ts"
export * from "./KimMJComponent.vue?vue&type=script&lang=ts"
import style0 from "./KimMJComponent.vue?vue&type=style&index=0&id=47b5716b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b5716b",
  null
  
)

export default component.exports